import { render, staticRenderFns } from "./resultUpgrade.vue?vue&type=template&id=19aa338e&scoped=true&"
import script from "./resultUpgrade.vue?vue&type=script&lang=js&"
export * from "./resultUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./resultUpgrade.vue?vue&type=style&index=0&id=19aa338e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa338e",
  null
  
)

component.options.__file = "resultUpgrade.vue"
export default component.exports